import { PasswordRule } from "../../types/admin";

type PasswordRuleListProps = {
  rules: PasswordRule[];
};

export const PasswordRuleList = ({ rules }: PasswordRuleListProps) => {
  return (
    <ul
      aria-live="polite"
      className="password-rule-list"
    >
      {rules.map((rule) => (
        <li
          className={`password-rule ${rule.met ? "is-met" : "is-unmet"}`}
          key={rule.id}
        >
          {rule.label}
        </li>
      ))}
    </ul>
  );
};
